"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const core_1 = require("@emotion/core");
const common_utils_1 = require("@zapier/common-utils");
const design_system_1 = require("@zapier/design-system");
const design_system_patterns_1 = require("@zapier/design-system-patterns");
const ServiceIcon_1 = __importDefault(require("./ServiceIcon"));
const containerStyles = core_1.css `
  border-radius: inherit;
  overflow: hidden;
  text-align: center;
`;
const headerStyles = core_1.css `
  padding: 50px 0;
  background-color: ${design_system_1.Colors.green400};
`;
const contentStyles = core_1.css `
  padding: 30px;
`;
const Popover = ({ href, isOpen, services }) => {
    const [open, setOpen] = react_1.useState(isOpen);
    react_1.useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);
    const closePopover = () => {
        setOpen(false);
    };
    if (!open) {
        return null;
    }
    return (common_utils_1.isolateComponent(design_system_1.FloatingBox, { align: "right", maxWidth: "300px", minWidth: "300px", onClickOutside: closePopover, position: "south" },
        common_utils_1.isolateComponent("div", { css: containerStyles },
            common_utils_1.isolateComponent("div", { css: headerStyles },
                common_utils_1.isolateComponent(design_system_patterns_1.ZapServiceIcons, { height: 60, maxServices: 3, renderServiceIcon: (service, index) => (common_utils_1.isolateComponent(ServiceIcon_1.default, { isInGroup: true, key: `${service}_${index}`, serviceName: service !== null && service !== void 0 ? service : '', size: 60 })), services: services })),
            common_utils_1.isolateComponent("div", { css: contentStyles },
                common_utils_1.isolateComponent(design_system_1.Text, { margin: "0 0 10px 0", tag: "h3", textAlign: "center", type: "subtitle900" }, "Your Zap is on!"),
                common_utils_1.isolateComponent(design_system_1.Text, { margin: "0 0 40px 0", tag: "p", textAlign: "center", type: "bodyText800" }, "You can turn off your Zap at any time by toggling this switch"),
                common_utils_1.isolateComponent(design_system_1.Button, { hasShadow: true, href: href }, "Go To My Zaps")))));
};
exports.default = Popover;
